module.exports = __webpack_public_path__ + "static/media/snow_privatization_en.6f4481fd.md";